// work data

export const Work = [
{
    id:1,
    name:"AI Form Helper – Chrome Extension",
 description:"AI-powered Chrome extension that analyzes online form questions and suggests answers using Groq AI (LLaMA 3.3 70B).",
    tags:["chrome-extension","ai","groq-api","automation"],
    
    demo:"https://chromewebstore.google.com/detail/quizbot-ai/eofcjnghgenmffccgkapnibajagkfoao",
    github:"https://github.com/RajaretnamR/Ai-MCQ-Helper"
},
{
    id:7,
    name:"CareerCraft AI Resume Builder",
    description:"Builds ATS-ready resumes with AI-generated experience points, live preview, and instant PDF export.",
    tags:["react","vite","firebase","groq-api","ai"],
    
    demo:"https://career-craft-resume-beta.vercel.app/",
    github:"https://github.com/RajaretnamR/CareerCraft-Resume-MERN"
},
{
        id:5,
        name:"Todo App(React + Redux)",
        description:"A todo app build using Redux-toolkit and framer-motion for smooth animations.",
        tags:["react","redux","framer-motion"],
        
        demo:"https://react-todo-list-ecru-kappa.vercel.app/",
        github:"https://github.com/RajaretnamR/React-Todo-List"
        
},
{
    id:2,
    name:"P2P File Sharing System",
    description:"A peer-to-peer file sharing system that allows users to transfer files directly between devices without a central server.",
    tags:["typescript","rust","p2p","web","file-transfer"],
    
    demo:"https://p2ptransfer.app/",
    github:"https://github.com/RajaretnamR/P2P-File"
},
{
    id:3,
    name:"AI Counter Application",
    description:"An AI-powered counter application built with React and Tailwind CSS that tracks micro, macro, and custom results using OpenRouter (Gemini 2.0 Flash) integration.",
    tags:["react","vite","tailwindcss","ai","openrouter"],
    
    demo:"#",
    github:"https://github.com/RajaretnamR/Ai-Counter-web"
},
{
    id:4,
    name:"MyFlix OTT Web App",
    description:"A movie browsing web application that fetches real-time movie data using the TMDB API and displays now-playing, top-rated, and upcoming movies in an OTT-style interface.",
    tags:["html","css","javascript","tmdb-api","movies"],
    
    demo:"#",
    github:"https://github.com/RajaretnamR/MyFlix-OTT-Web_App"
},
{
    id:6,
    name:"Coffee Shop Landing Website",
    description:"A modern and responsive coffee shop landing page designed with HTML, CSS, and JavaScript featuring smooth UI sections and  media integration.",
    tags:["html","css","javascript","ui-design","landing-page"],
    
    demo:"#",
    github:"https://github.com/RajaretnamR/Coffee-Webiste"
},
    
  
] 